import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { adminStats } from "@/lib/inmindApi";

export default function AdminSettingsPage() {
  const [s, setS] = useState(null);

  useEffect(() => { adminStats().then(setS).catch(() => {}); }, []);

  if (!s) {
    return <div className="flex items-center justify-center py-24 text-[var(--inmind-muted)]"><Loader2 className="w-5 h-5 animate-spin mr-2" /> Loading…</div>;
  }
  return (
    <div data-testid="admin-settings-page" className="space-y-5">
      <Card className="rounded-2xl border border-black/5 bg-white shadow-[0_4px_18px_rgba(0,0,0,0.03)]">
        <CardContent className="p-6 space-y-3">
          <div className="text-[10px] tracking-[0.22em] uppercase font-semibold text-[var(--inmind-muted)]">
            System
          </div>
          <p className="text-sm text-[var(--inmind-text-secondary)]">
            InThink is running with daily card generation via gpt-5.1 (Emergent LLM Key).
            Use the <span className="text-[var(--inmind-text)] font-medium">Terms</span> page to generate or edit cards.
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 pt-3">
            <Row k="Total users" v={s.total_users} />
            <Row k="Total terms" v={s.total_terms} />
            <Row k="Total reviews" v={s.total_reviews} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

function Row({ k, v }) {
  return (
    <div className="rounded-xl border border-black/5 bg-[var(--inmind-card-subtle)] p-3">
      <div className="text-[10px] tracking-[0.18em] uppercase font-semibold text-[var(--inmind-muted)]">{k}</div>
      <div className="font-serif text-2xl text-[var(--inmind-text)] tabular-nums mt-1">{v}</div>
    </div>
  );
}
